import React from 'react';
import {
    Show,
    TabbedShowLayout,
    Tab,
    TextField,
    EmailField,
    NumberField,
    ReferenceField, NumberInput,
    CardActions,
    EditButton,
    ArrayField,
    Datagrid,
    BooleanField,

} from 'react-admin';

import Button from '../common/Button'

import CustomMFAField from "./CustomMFAField"
import withStyles from '@material-ui/core/styles/withStyles';

const styles = {
    inlineBlock: { display: 'inline-flex', marginRight: '1rem' },
};

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
    marginLeft: '1rem'
};
const AccountShow = ({permissions, classes, ...props}) => {
    const isAdmin = permissions === 'system_admin';
    // 你可以根据需要设置这个条件，比如基于权限、数据状态等
    const showEditButton = permissions === 'system_admin' || permissions === 'operator' || permissions === 'store_owner'; // 设置为 false 来隐藏编辑按钮

    return (
    <Show title="Account" {...props} actions={<MyShowActions isAdmin={isAdmin} showEditButton={showEditButton} />}>
        <TabbedShowLayout>
            <Tab label="resources.accounts.tabs.identity">
                <TextField
                    source="companyName" formClassName={classes.inlineBlock}
                />
                <TextField
                    source="registrationNumber" formClassName={classes.inlineBlock}
                />
                <TextField
                    source="formationDate" formClassName={classes.inlineBlock}
                />
                <TextField
                    source="countrySymbol" formClassName={classes.inlineBlock}
                />
                <TextField
                    source="currencySymbol" formClassName={classes.inlineBlock}
                />
                <EmailField
                    source="email"
                />
                <TextField source="accountNumber" />
                {(permissions === 'operator' || permissions === 'system_admin' || permissions === 'support') ? [
                    <TextField source="creditLimit" label="Credit Limit" />,
                    <TextField source="notifyUpperLimit" label="Sell Notify Upper Limit" />,
                    <CustomMFAField source="approved" label="Account Approved"/>,
                    <TextField source="notes" label="Notes" />
                ] : null
                }
            </Tab>
            <Tab label="Business Address">
                <TextField source="address.address2" label="Unit Number"/>
                <TextField source="address.address1" label="Address"/>
                <TextField source="address.city" label="City" />
                <TextField source="address.state" label="State"/>
                <TextField source="address.postalCode" label="Postal Code"/>
                <TextField source="address.country" label="Country" />
            </Tab>
            {(permissions === 'operator' || permissions === 'system_admin' || permissions === 'support') && (
                <Tab label="Locations">
                    <ArrayField source="locations" addLabel={false}>
                        <Datagrid>
                            <TextField source="nickName" label="Store Name"/>
                            <TextField source="address.address2" label="Unit Number"/>
                            <TextField source="address.address1" label="Street Address"/>
                            <TextField source="address.city" label="City"/>
                            <TextField source="address.state" label="State"/>
                            <TextField source="address.postalCode" label="Postal Code"/>
                        </Datagrid>
                    </ArrayField>
                </Tab>
            )}
            {/* <Tab label="resources.accounts.tabs.credit">
                <TextField source="countrySymbol" />
                <TextField source="accountNumber" />
                <NumberField source="credit"/>
            </Tab> */}
            <Tab label="User Info">
                <TextField source="user.name" label="Name" formClassName={classes.inlineBlock} />
                <TextField source="user.firstName" label="First Name" formClassName={classes.inlineBlock} />
                <TextField source="user.lastName" label="Last Name" formClassName={classes.inlineBlock} />
                <EmailField source="user.email" label="Email" formClassName={classes.inlineBlock} />
                <TextField source="user.phoneNumber" label="Phone Number" formClassName={classes.inlineBlock} />
                <TextField source="user.dateOfBirth" label="Date of Birth" formClassName={classes.inlineBlock} />
            </Tab>
            <Tab label="resources.accounts.tabs.settings">
                <CustomMFAField source="isMFA" label="Multi Factor Authentication"/>
            </Tab>
        </TabbedShowLayout>
    </Show>
    );
};

export const MyShowActions = ({ isAdmin, basePath, data, resource, showEditButton = true }) => {

    const onEditCoinRate = () => {
        console.log("onEditCoinRate", data);
        window.location.href = `#/accountcoins/${data.id}/show`;
    }

    return (
        <CardActions style={cardActionStyle}>
            {showEditButton && <EditButton basePath={basePath} record={data} />}
            {isAdmin && <Button color="primary" variant="contained" size="small" onClick={onEditCoinRate}>Edit coin rate</Button>}
        </CardActions>
    )
}


export default withStyles(styles)(AccountShow);
